import styled from "styled-components";
import type { GlobalToken } from "antd";

export const LinkRow = styled.div<{ $token: GlobalToken }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid ${({ $token }) => $token.colorBorder};
  border-radius: ${({ $token }) => $token.borderRadiusLG}px;
  background: ${({ $token }) => $token.colorBgContainer};

  /* Give the remove action a subtle square outline that turns red on hover.
     The lib IconButton is an antd default button, so antd forces a teal
     (colorPrimaryHover) border on hover; override it with !important — matching
     the danger icon/background instead of leaking the brand color. */
  .link-remove {
    border: 1px solid ${({ $token }) => $token.colorBorder};
  }
  .link-remove:hover {
    border-color: ${({ $token }) => $token.colorError} !important;
  }
`;

export const BareField = styled.div`
  flex: 1 1 0;
  min-width: 0;

  /* The row already carries a border, so the inner inputs stay borderless in
     every state (default / hover / focus). */
  .ant-input,
  .ant-input:hover,
  .ant-input:focus,
  .ant-input-focused {
    padding-inline: 0;
    border-color: transparent;
    background: transparent;
    box-shadow: none;
  }
`;

export const RowSeparator = styled.span<{ $token: GlobalToken }>`
  align-self: stretch;
  width: 1px;
  margin: 4px 0;
  background: ${({ $token }) => $token.colorBorderSecondary};
`;

/** Unstyled button wrapping the type IconChip so it opens the type dropdown
 *  while staying keyboard-focusable. */
export const TypeTrigger = styled.button`
  display: inline-flex;
  flex: none;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;
